// @flow
import * as React from 'react';
import { Box } from '@mui/material';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';

export const TickIcon = ({shouldReduceMotion}: {shouldReduceMotion?: boolean}) => (
  <motion.div
    initial={shouldReduceMotion ? false : { scale: 0 }}
    animate={{ scale: 1 }}
    transition={shouldReduceMotion ? { duration: 0 } : { type: 'spring', stiffness: 500, damping: 15 }}
    aria-hidden="true"
  >
    <Box sx={{minWidth: 24, minHeight: 24, bgcolor: '#15803d', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <Check size={16} color={'#fff'} />
    </Box>
  </motion.div>
);
